import { render, staticRenderFns } from "./BasicOfferingCard.vue?vue&type=template&id=4794463c&scoped=true&"
import script from "./BasicOfferingCard.vue?vue&type=script&lang=ts&"
export * from "./BasicOfferingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BasicOfferingCard.vue?vue&type=style&index=0&id=4794463c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794463c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCard,VCol,VIcon,VImg,VLayout,VRow,VSkeletonLoader,VThemeProvider})
